import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BillingAddress, MarketplaceBillingInformationState } from '@platform-frontend/marketplace';
import { InvalidStateError, throwIfNullish } from '@platform-frontend/util';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BillingAddressService {
  constructor(private store: Store) {}

  billingAddresses$: Observable<BillingAddress[]> = this.store.select(MarketplaceBillingInformationState.billingAddresses);

  getEditableBillingAddress(id: number | null, selectedCountry$: Observable<string | null>): Observable<Partial<BillingAddress>> {
    const requestedAddress$ = this.billingAddresses$.pipe(map(billingAddresses => billingAddresses.find(address => address.id === id) ?? null));

    const addressFromSelectedCountry$ = selectedCountry$.pipe(
      throwIfNullish(() => new InvalidStateError('Cannot initialize billing address due to missing country data')),
      map(country => ({ country }))
    );

    return requestedAddress$.pipe(switchMap(requestedAddress => (requestedAddress === null ? addressFromSelectedCountry$ : of(requestedAddress))));
  }
}
